import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export type PumpInfoType = 'time' | 'completing' | 'completed';
interface UIState {
  infoSideBar: {
    isOpen: boolean;
    showMore: boolean;
  };
  emailLogin: {
    isOpen: boolean;
  };
  emailRegister: {
    isOpen: boolean;
  };
  walletLogin: {
    isOpen: boolean;
  };
  pumpInfo: {
    type: PumpInfoType;
  };
  currencySelector: {
    isOpen: boolean;
  };
  tokenWarning: {
    freezableOpen: boolean;
    liquidityOpen: boolean;
  };
}

const initialState: UIState = {
  infoSideBar: {
    isOpen: true,
    showMore: false,
  },
  emailLogin: {
    isOpen: false,
  },
  walletLogin: {
    isOpen: false,
  },
  emailRegister: {
    isOpen: false,
  },
  pumpInfo: {
    type: 'time',
  },
  currencySelector: {
    isOpen: false,
  },
  tokenWarning: {
    freezableOpen: false,
    liquidityOpen: false,
  },
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleInfoSideBar: (state) => {
      state.infoSideBar.isOpen = !state.infoSideBar.isOpen;
    },
    setInfoSideBarOpen: (state, action: PayloadAction<boolean>) => {
      state.infoSideBar.isOpen = action.payload;
    },
    toggleEmailLogin: (state) => {
      state.emailLogin.isOpen = !state.emailLogin.isOpen;
    },
    setEmailLoginOpen: (state, action: PayloadAction<boolean>) => {
      state.emailLogin.isOpen = action.payload;
    },
    toggleWalletLogin: (state) => {
      state.walletLogin.isOpen = !state.walletLogin.isOpen;
    },
    setWalletLoginOpen: (state, action: PayloadAction<boolean>) => {
      state.walletLogin.isOpen = action.payload;
    },
    toggleEmailRegister: (state) => {
      state.emailRegister.isOpen = !state.emailRegister.isOpen;
    },
    setEmailRegisterOpen: (state, action: PayloadAction<boolean>) => {
      state.emailRegister.isOpen = action.payload;
    },
    toggleShowMore: (state) => {
      state.infoSideBar.showMore = !state.infoSideBar.showMore;
    },
    setShowMore: (state, action: PayloadAction<boolean>) => {
      state.infoSideBar.showMore = action.payload;
    },
    setPumpInfoType: (
      state,
      action: PayloadAction<'time' | 'completing' | 'completed'>,
    ) => {
      state.pumpInfo.type = action.payload;
    },
    toggleCurrencySelector: (state) => {
      state.currencySelector.isOpen = !state.currencySelector.isOpen;
    },
    setCurrencySelectorOpen: (state, action: PayloadAction<boolean>) => {
      state.currencySelector.isOpen = action.payload;
    },
    setTokenWarningFreezableOpen: (state, action: PayloadAction<boolean>) => {
      state.tokenWarning.freezableOpen = action.payload;
    },
    setTokenWarningLiquidityOpen: (state, action: PayloadAction<boolean>) => {
      state.tokenWarning.liquidityOpen = action.payload;
    },
  },
});

// 导出 actions
export const {
  toggleInfoSideBar,
  setInfoSideBarOpen,
  toggleEmailLogin,
  setEmailLoginOpen,
  toggleWalletLogin,
  setWalletLoginOpen,
  toggleShowMore,
  setShowMore,
  setPumpInfoType,
  toggleEmailRegister,
  setEmailRegisterOpen,
  toggleCurrencySelector,
  setCurrencySelectorOpen,
  setTokenWarningFreezableOpen,
  setTokenWarningLiquidityOpen,
} = uiSlice.actions;

// 导出 selectors
export const selectInfoSideBarOpen = (state: RootState) =>
  state.ui.infoSideBar.isOpen;

export const selectEmailLoginOpen = (state: RootState) =>
  state.ui.emailLogin.isOpen;
export const selectWalletLoginOpen = (state: RootState) =>
  state.ui.walletLogin.isOpen;
export const selectEmailRegisterOpen = (state: RootState) =>
  state.ui.emailRegister.isOpen;

export const selectShowMore = (state: RootState) =>
  state.ui.infoSideBar.showMore;

export const selectPumpInfoType = (state: RootState) => state.ui.pumpInfo.type;

export const selectCurrencySelectorOpen = (state: RootState) =>
  state.ui.currencySelector.isOpen;

export const selectTokenWarningFreezableOpen = (state: RootState) =>
  state.ui.tokenWarning.freezableOpen;

export const selectTokenWarningLiquidityOpen = (state: RootState) =>
  state.ui.tokenWarning.liquidityOpen;

export default uiSlice.reducer;
